export default __webpack_public_path__ + "static/media/528hz-deep-meditation.4134a9d1.ogg";